module.exports = __webpack_public_path__ + "static/media/cart.4a57e86c.svg";